import { analyticsClient } from "./client";

const track = (eventName, properties = {}) => analyticsClient.track(eventName, {
  product: "general",
  path: "/complete-profile",
  properties,
});

export const trackPhoneSubmitAttempted = () => track("phone_submit_attempted", {
  source: "mandatory_contact_screen",
});

export const trackPhoneSubmitFailed = (reason) => track("phone_submit_failed", {
  source: "mandatory_contact_screen",
  reason,
});

export const trackPhonePromptExited = () => track("phone_prompt_exited", {
  source: "mandatory_contact_screen",
});
